import React from "react";

import { Route, useLocation, Redirect } from "react-router-dom";

import { useSelector } from "react-redux";

import LocationState from "./LocationState";

import { RootState } from "../store";

const LoginRequiredRoute = ({ ...props }) => {
  const location = useLocation<LocationState>();
  const isLoggedIn = useSelector((state: RootState) => state.user.loggedIn);

  if (!isLoggedIn) {
    return (
      // The search string travels too: an OAuth consent link carries the
      // signed request in it, and dropping it sends the person back to a page
      // that no longer knows what it was asked to authorise.
      <Redirect
        to={{
          pathname: "/login",
          state: { from: `${location.pathname}${location.search}` },
        }}
      />
    );
  }
  return <Route {...props}></Route>;
};

export default LoginRequiredRoute;
